import { GridColumn } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import { GridCellProps, GridFooterCellProps } from "@progress/kendo-react-grid";
import { PUDODropdownCell } from "./PUDODropdownCell";
import StopDataDaysMaxCell from "./Footer/StopDataDaysMaxCell";
import StopDataKmSumCell from "./Footer/StopDataKmSumCell";
import StopDataDrivingHoursSumCell from "./Footer/StopDataDrivingHoursSumCell";
import { StopDataFooterProps } from "./Footer/StopDataFooterProps";
import { isArrayUndefinedOrEmpty } from "../../../../../Utils/arrays";
import { KendoReactColoredFooterCell } from "../../../../../Layout/Grid/Cell/KendoReactColoredFooterCell";
import { maskedHourMinuteWithSeparatorGridCell } from "./MaskedKendoGridCell.custom";
import { ReadOnlyProps } from "../../../ReadOnlyProps";

type Props = {
  stopDataIsEditable: boolean;
};

export const stopDataGridColums = ({
  routings,
  stopDataIsEditable,
  isReadOnly,
}: StopDataFooterProps & Props & ReadOnlyProps) => {
  const stopDataDaysMax = (props: GridFooterCellProps) => (
    <StopDataDaysMaxCell {...props} routings={routings} />
  );
  const stopDataKmSum = (props: GridFooterCellProps) => (
    <StopDataKmSumCell {...props} routings={routings} />
  );

  const stopDataDrivingHoursSum = (props: GridFooterCellProps) => {
    return <StopDataDrivingHoursSumCell {...props} routings={routings} />;
  };

  const pudoDropdownCell = (props: GridCellProps) =>
    PUDODropdownCell({
      ...props,
      onRowClick: () => undefined,
      editable: stopDataIsEditable,
      isReadOnly,
    });

  const kendoReactColoredFooterCell = (cellText?: string) => {
    return !isArrayUndefinedOrEmpty(routings) ? (
      <KendoReactColoredFooterCell cellText={cellText} />
    ) : null;
  };

  return [
    <GridColumn
      key="PuDoType"
      field="PuDoType"
      title="PU / DO"
      filter="text"
      cell={pudoDropdownCell}
      editable={stopDataIsEditable}
      width="110px"
      footerCell={() => kendoReactColoredFooterCell("Total")}
    />,
    <GridColumn
      key="Gsdb"
      field="Gsdb"
      title="GSDB"
      filter="text"
      editable={false}
      footerCell={() => kendoReactColoredFooterCell()}
    />,
    <GridColumn
      key="DockCode"
      field="DockCode"
      title="Dock"
      filter="text"
      editable={false}
      width="60px"
      footerCell={() => kendoReactColoredFooterCell()}
    />,
    <GridColumn
      key="LocationName"
      field="LocationName"
      title="Location Name"
      filter="text"
      editable={false}
      footerCell={() => kendoReactColoredFooterCell()}
    />,
    <GridColumn
      key="City"
      field="City"
      title="City"
      filter="text"
      editable={false}
      footerCell={() => kendoReactColoredFooterCell()}
    />,
    <GridColumn
      key="Postcode"
      field="Postcode"
      title="Post Code"
      filter="text"
      editable={false}
      footerCell={() => kendoReactColoredFooterCell()}
    />,
    <GridColumn
      key="Country"
      field="Country"
      title="Country"
      filter="text"
      editable={false}
      footerCell={() => kendoReactColoredFooterCell()}
    />,
    <GridColumn
      key="Day"
      field="Day"
      title="Day"
      editor="numeric"
      filter="numeric"
      footerCell={stopDataDaysMax}
      editable={stopDataIsEditable}
    />,
    <GridColumn
      key="ETA"
      field="ETA"
      title="ETA"
      filter="date"
      editable={stopDataIsEditable}
      cell={(props) =>
        maskedHourMinuteWithSeparatorGridCell({
          gridCellProps: props,
          isEditable: stopDataIsEditable,
          ftlRoutingViewModelStopDataKey: "ETA",
        })
      }
      footerCell={() => kendoReactColoredFooterCell()}
    />,
    <GridColumn
      key="ETD"
      field="ETD"
      title="ETD"
      filter="date"
      editable={stopDataIsEditable}
      cell={(props) =>
        maskedHourMinuteWithSeparatorGridCell({
          gridCellProps: props,
          isEditable: stopDataIsEditable,
          ftlRoutingViewModelStopDataKey: "ETD",
        })
      }
      footerCell={() => kendoReactColoredFooterCell()}
    />,
    <GridColumn
      key="Km"
      field="Km"
      title="Km"
      filter="numeric"
      footerCell={stopDataKmSum}
      editor="numeric"
      editable={stopDataIsEditable}
    />,
    <GridColumn
      key="DrivingHours"
      field="DrivingHours"
      title="Driving Hours"
      filter="text"
      footerCell={stopDataDrivingHoursSum}
      editable={stopDataIsEditable}
      cell={(props) =>
        maskedHourMinuteWithSeparatorGridCell({
          gridCellProps: props,
          isEditable: stopDataIsEditable,
          ftlRoutingViewModelStopDataKey: "DrivingHours",
          isDrivingHour: true,
        })
      }
    />,
  ];
};
